import { UploadFileRounded } from '@mui/icons-material';
import { Box, Stack, Tooltip, Typography } from '@mui/material';

interface FileUploadNameProps {
  fileName: string;
}

export const FileUploadName = ({ fileName }: FileUploadNameProps) => {
  return (
    <Stack alignContent="center" direction="row" spacing={0.5}>
      <UploadFileRounded color="primary" fontSize="small" />
      <Box overflow="hidden" textOverflow="ellipsis" maxWidth="150px">
        <Tooltip title={fileName} placement="top">
          <Typography variant="body2" noWrap>
            {fileName}
          </Typography>
        </Tooltip>
      </Box>
    </Stack>
  );
};
